// assets/contact-logging-leachs.js
document.addEventListener("DOMContentLoaded", function () {
  try {
    // 1) Find the specific Salesforce form
    var form = document.getElementById("dynamicForm");
    if (!form) return;

    // 2) Extra safety: only attach if it's the Salesforce WebTo form
    var action = (form.getAttribute("action") || "").toLowerCase();
    if (
      !action.includes("webto.salesforce.com/servlet/servlet.webto") &&
      !action.includes("webto.salesforce.com/servlet/servlet.webtocase") &&
      !action.includes("webto.salesforce.com/servlet/servlet.webtolead")
    ) {
      return;
    }

    // 3) Attach a single submit listener
    form.addEventListener("submit", function () {
      try {
        // Core fields
        var firstNameEl = form.querySelector("#first_name");
        var lastNameEl = form.querySelector("#last_name");
        var emailEl = form.querySelector("#email");
        var phoneEl = form.querySelector("#phone");
        var descriptionEl = form.querySelector("textarea[name='description']");

        var firstName = firstNameEl ? firstNameEl.value.trim() : "";
        var lastName = lastNameEl ? lastNameEl.value.trim() : "";
        var fullName = (firstName + " " + lastName).trim();

        var payload = {
          site: "leachs", // so your backend can route/tag it
          name: fullName || null,
          email: emailEl ? emailEl.value.trim() : "",
          phone: phoneEl ? phoneEl.value.trim() : "",
          message: descriptionEl ? descriptionEl.value.trim() : "",
          sourceUrl: window.location.href,
        };

        // 4) Collect extra fields
        var extraFields = [];

        function addExtra(fieldSelector, key, label) {
          var el = form.querySelector(fieldSelector);
          if (!el) return;

          var value = "";
          if (el.tagName === "SELECT") {
            value = el.value || "";
          } else {
            value = el.value || "";
          }
          value = value.trim();
          if (!value) return;

          extraFields.push({
            key: key,
            label: label,
            value: value,
          });
        }

        // Visible fields
        addExtra("#company", "company", "Company");
        addExtra("#city", "city", "City");
        addExtra("#state", "state", "State/Province");
        addExtra("#regarding", "regarding", "Regarding");
        addExtra("#subject", "subject", "Subject");

        // Hidden Salesforce meta fields
        addExtra("input[name='type']", "type", "Case Type");
        addExtra("input[name='status']", "status", "Status");
        addExtra("input[name='origin']", "origin", "Origin");
        addExtra("input[name='priority']", "priority", "Priority");
        addExtra("input[name='lead_source']", "lead_source", "Lead Source");

        if (extraFields.length > 0) {
          payload.extraFields = extraFields;
        }

        // 5) Send to app proxy
        fetch("/apps/toolbox-leachs/api/contact", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload),
          keepalive: true, // so it still fires even on navigation
        }).catch(function (err) {
          console.warn("[Leachs contact logging] fetch failed:", err);
        });
      } catch (err) {
        console.warn("[Leachs contact logging] runtime error:", err);
      }
    });
  } catch (err) {
    console.warn("[Leachs contact logging] init error:", err);
  }
});
